import { render, staticRenderFns } from "./ItemGtins.vue?vue&type=template&id=72db288e&scoped=true&"
import script from "./ItemGtins.vue?vue&type=script&lang=js&"
export * from "./ItemGtins.vue?vue&type=script&lang=js&"
import style0 from "./ItemGtins.vue?vue&type=style&index=0&id=72db288e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72db288e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VTooltip})
